export default {
    /**
     * Cancel docid's invoice and create a credinote
     * for this invoice
     *
     * @todo : replace Jquery call by WebServiceCaller
     * @param {number} docid
     * @returns {Promise}
     */
    cancelInvoiceByCreditnote(docid) {
        return new Promise((resolve, reject) => {
            const data = {
                action: 'cancelInvoiceByCreditnote',
                docid: docid,
            };

            $.ajax({
                type: 'POST',
                url: '/?_f=doc',
                data: data,
                success: resolve,
                error: reject,
                dataType: 'json',
            });
        });
    },

    /**
     * Get all accounting codes from corp
     *
     * @returns {Promise}
     */
    getAccountingCodes(query) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `rest/accounting/codes`,
                { q: query },
                (response) => {
                    resolve(Object.values(response.accountingCodes));
                },
            );
        });
    },

    /**
     * Get accounting code id for a row
     *
     * @param {number} rowid
     * @returns {Promise}
     */
    getAccountingCodeForRow(rowid) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `accounting/sale/document/row/${rowid}`,
                {},
                (response) => {
                    resolve(response);
                },
            );
        });
    },

    /**
     * Set accounting code id for a row
     *
     * @param {number} rowid
     * @param {number} accountingCodeId
     * @returns {Promise}
     */
    setAccountingCodeForRow(rowid, accountingCodeId) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.patch(
                `accounting/sale/document/row/${rowid}/code/${accountingCodeId}`,
                {},
                {},
                (response) => {
                    resolve(response);
                },
            );
        });
    },

    /**
     * @param {string} doctype
     * @param {number} docid
     * @param {boolean} value
     * @returns {Promise}
     */
    toggleDunningForDoc(doctype, docid, value) {
        var action = value == 'enabled' ? 'disable' : 'enable';
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.patch(
                `/rest/documents/${doctype}/${docid}/dunning/${action}`,
                {},
                {},
                (response) => {
                    resolve(response);
                },
            ).catch((error) => {
                Push.error(
                    error?.response?.data?.error?.message ??
                        this.$l10n.__('Une erreur est survenue lors du traitement.'),
                );
            });
        });
    },

    /**
     * @param {string} doctype
     * @param {number} docid
     * @param {number} page
     */
    getSentDunnings(doctype, docid, page) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `/rest/documents/${doctype}/${docid}/dunning/sent`,
                { page: page },
                (response) => {
                    resolve(response);
                },
            );
        });
    },

    /**
     * @param {string} doctype
     * @param {number} docid
     */
    getPlannedDunnings(doctype, docid) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `/rest/documents/${doctype}/${docid}/dunning/planned`,
                {},
                (response) => {
                    resolve(response);
                },
            );
        });
    },

    /**
     * Get all margin resources linked for one doc
     *
     * @param {string} doctype
     * @param {number} docid
     * @param {string} context
     * @returns {Promise}
     */
    getLinkedResource(doctype, docid, context) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `/rest/documents/${doctype}/${docid}/linked/${context}`,
                {},
                (response) => {
                    resolve(response);
                },
            );
        });
    },

    /**
     * Remove one linked element from a document
     *
     * @param {number} id
     * @returns {Promise}
     */
    deleteLink(id) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.del(`/rest/documents/linked/${id}`, {}, (response) => {
                resolve(response);
            });
        });
    },

    /**
     * Add one custom entry link for a document
     *
     * @param {string} doctype
     * @param {number} docid
     * @param {array} customEntry
     * @returns {Promise}
     */
    addCustomLink(doctype, docid, customEntry) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.post(
                `/rest/documents/${doctype}/${docid}/linked/custom`,
                {},
                customEntry,
                (data) => resolve(data),
                (error) => reject(error),
            );
        });
    },

    /**
     * Update a custom entry link to a document
     *
     * @param {string} doctype
     * @param {number} docid
     * @param {array} customEntry
     * @returns {Promise}
     */
    updateCustomLink(doctype, docid, customEntry) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.put(
                `/rest/documents/${doctype}/${docid}/linked/custom`,
                {},
                customEntry,
                (data) => resolve(data),
                (error) => reject(error),
            );
        });
    },

    /**
     * Get statistics for a document
     *
     * @param {string} doctype
     * @param {number} docid
     * @returns {Promise}
     */
    getStatistics(doctype, docid) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `/rest/documents/${doctype}/${docid}/kpi`,
                {},
                (data) => resolve(data),
                (error) => reject(error),
            );
        });
    },

    /**
     * Impact margin for resources
     *
     * @param {string} doctype
     * @param {number} docid
     * @param {string} resource
     * @param {Array} ids
     * @returns {Promise}
     */
    processMargin(doctype, docid, resource, ids) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.patch(
                `/rest/documents/${doctype}/${docid}/${resource}/process-margin`,
                {},
                { id: ids },
                (data) => resolve(data),
                (error) => reject(error),
            );
        });
    },

    /**
     * Valide document
     *
     * @param {string} doctype
     * @param {number} docid
     * @returns {Promise}
     */
    validate(doctype, docid, date) {
        const param = {};
        if (date !== undefined) {
            param.displayedDate = date;
        }
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.patch(
                `/rest/documents/${doctype}/${docid}/validate`,
                {},
                param,
                (data) => resolve(data),
                (error) => reject(error),
            );
        });
    },
};
